import ArticleRelated from './articleRelated';

ArticleRelated();
